import { DeleteResponsibleOutDto, DeleteResponsibleInDto } from '../../../types/responsible.dto'

export const DELETE_RESPONSIBLE = 'DELETE_RESPONSIBLE'
export const DELETE_RESPONSIBLE_SUCCESS = 'DELETE_RESPONSIBLE_SUCCESS'
export const DELETE_RESPONSIBLE_ERROR = 'DELETE_RESPONSIBLE_ERROR'
export const RESET_DELETE_RESPONSIBLE = 'RESET_DELETE_RESPONSIBLE'

export interface DeleteResponsible {
  type: typeof DELETE_RESPONSIBLE
  payload: DeleteResponsibleOutDto
}

export interface DeleteResponsibleSuccess {
  type: typeof DELETE_RESPONSIBLE_SUCCESS
  payload: DeleteResponsibleInDto
}

export interface DeleteResponsibleError {
  type: typeof DELETE_RESPONSIBLE_ERROR
  payload: string | boolean
}

export interface ResetDeleteResponsible {
  type: typeof RESET_DELETE_RESPONSIBLE
  payload: null
}

export interface State {
  data: DeleteResponsibleInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = DeleteResponsible | DeleteResponsibleSuccess | DeleteResponsibleError | ResetDeleteResponsible
